
    (() => {
      const SECTION_ID = 'cc-pdp-complete-template--22142084448508__custom_product_qkafDR';
      const SECTION_UID = 'template--22142084448508__custom_product_qkafDR';

      // ============================================================
      // FAQ — runs immediately, does NOT depend on Swiper
      // ============================================================
      const initFaq = (root) => {
        root.querySelectorAll('.cc-pdp-faqs').forEach((faqGroup) => {
          const items = Array.from(faqGroup.querySelectorAll('.cc-pdp-faqs__item'));

          const closeItem = (item) => {
            item.classList.remove('is-open');
            const button = item.querySelector('.cc-pdp-faqs__toggle');
            if (button) button.setAttribute('aria-expanded', 'false');
          };

          const openItem = (item) => {
            item.classList.add('is-open');
            const button = item.querySelector('.cc-pdp-faqs__toggle');
            if (button) button.setAttribute('aria-expanded', 'true');
          };

          items.forEach((item) => {
            const button = item.querySelector('.cc-pdp-faqs__toggle');
            if (!button || button.dataset.bound === 'true') return;
            button.dataset.bound = 'true';

            button.addEventListener('click', (e) => {
              e.preventDefault();
              const isOpen = item.classList.contains('is-open');
              items.forEach((other) => {
                if (other !== item) closeItem(other);
              });
              if (isOpen) closeItem(item); else openItem(item);
            });
          });
        });
      };

      // ============================================================
      // Video controls — click centered play button to play. When
      // playing, hover reveals pause + sound-toggle in bottom-right.
      // ============================================================
      const initVideoPlayButtons = (root) => {
        root.querySelectorAll('.cc-pdp__video-slide').forEach((slide) => {
          if (slide.dataset.bound === 'true') return;
          slide.dataset.bound = 'true';

          const video = slide.querySelector('video');
          const playBtn = slide.querySelector('.cc-pdp__video-play');
          const pauseBtn = slide.querySelector('.cc-pdp__video-ctl--pause');
          const soundBtn = slide.querySelector('.cc-pdp__video-ctl--sound');

          if (!video) return;

          if (playBtn) {
            playBtn.addEventListener('click', (e) => {
              e.preventDefault();
              const p = video.play();
              if (p && typeof p.catch === 'function') p.catch(() => {});
            });
          }

          if (pauseBtn) {
            pauseBtn.addEventListener('click', (e) => {
              e.preventDefault();
              video.pause();
            });
          }

          if (soundBtn) {
            const syncSound = () => soundBtn.setAttribute('data-muted', String(video.muted));
            soundBtn.addEventListener('click', (e) => {
              e.preventDefault();
              video.muted = !video.muted;
              syncSound();
            });
            syncSound();
          }

          const play = () => slide.classList.add('is-playing');
          const stop = () => slide.classList.remove('is-playing');
          video.addEventListener('play', play);
          video.addEventListener('playing', play);
          video.addEventListener('pause', stop);
          video.addEventListener('ended', stop);
        });
      };

      // ============================================================
      // Product coordinator — reads the JSON block in this section,
      // tracks selected variant + selling plan, and syncs:
      //   • offer card selection state
      //   • all card prices (updated when subscribe toggles)
      //   • the buy-buttons snippet's hidden id + selling_plan inputs
      //   • the ATC button label ("Add To Cart • $107.00  $456.00")
      // ============================================================
      // Run FAQ + play buttons + coordinator NOW, whether Swiper loads or not
      const bootFaq = () => {
        const root = document.getElementById(SECTION_ID);
        if (root) {
          initFaq(root);
          initVideoPlayButtons(root);

        }
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bootFaq, { once: true });
      } else {
        bootFaq();
      }

      // ============================================================
      // Swiper loader — with polling to survive race conditions
      // (the previous version's `script.addEventListener('load')`
      //  never fired if the script was already loaded when we got
      //  to it, which killed every slider)
      // ============================================================
      const ensureSwiper = () => window.Swiper ? Promise.resolve() : Promise.reject(new Error('Swiper unavailable'));
      // ============================================================
      // Sliders — only run once Swiper is available
      // ============================================================
      const bootSliders = () => {
        const root = document.getElementById(SECTION_ID);
        if (!root || typeof Swiper === 'undefined') return;

        const syncThumbsHeight = () => {
          const main = root.querySelector('.cc-pdp__main-wrap');
          const wrap = root.querySelector('.cc-pdp__thumbs-wrap');
          if (!main || !wrap) return;
          const h = main.getBoundingClientRect().height;
          if (h > 0) {
            wrap.style.height = h + 'px';
            const el = root.querySelector('.cc-pdp__thumbs');
            if (el && el.swiper) el.swiper.update();
          }
        };

        const initMainGallery = () => {
          const thumbsEl = root.querySelector('.js-cc-pdp-thumbs-' + SECTION_UID);
          const mainEl = root.querySelector('.js-cc-pdp-main-' + SECTION_UID);

          if (!mainEl) return;

          let thumbsSwiper = null;

          if (thumbsEl && window.innerWidth > 767) {
            if (thumbsEl.swiper) thumbsEl.swiper.destroy(true, true);
            thumbsSwiper = new Swiper(thumbsEl, {
              direction: 'vertical',
              slidesPerView: 'auto',
              spaceBetween: 10,
              watchSlidesProgress: true,
              freeMode: true
            });
          }
if (mainEl.swiper) mainEl.swiper.destroy(true, true);

new Swiper(mainEl, {
  slidesPerView: 1.08,
  spaceBetween: 8,
  speed: 500,
  watchOverflow: true,

  thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,

  navigation: {
    prevEl: root.querySelector('.js-cc-pdp-main-prev-' + SECTION_UID),
    nextEl: root.querySelector('.js-cc-pdp-main-next-' + SECTION_UID)
  },

  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 10
    }
  },

  on: {
    init: syncThumbsHeight,
    imagesReady: syncThumbsHeight,
    slideChange: function () {
      syncThumbsHeight();
      // Keep the active thumb fully visible — fixes the last thumb
      // being cut off and prevents freeMode drift after main slide changes.
      if (thumbsSwiper && !thumbsSwiper.destroyed) {
        thumbsSwiper.slideTo(this.activeIndex, 300);
      }
    }
  }
});

          // Sync now and on window resize + when main image loads.
          syncThumbsHeight();
          window.addEventListener('resize', () => requestAnimationFrame(syncThumbsHeight));
          root.querySelectorAll('.cc-pdp__main-image').forEach((img) => {
            if (img.complete) return;
            img.addEventListener('load', syncThumbsHeight, { once: true });
          });

          // ResizeObserver on main-wrap gives us the most accurate sync
          if (typeof ResizeObserver !== 'undefined') {
            const main = root.querySelector('.cc-pdp__main-wrap');
            if (main) new ResizeObserver(syncThumbsHeight).observe(main);
          }
        };

        const initVideoSwiper = (selector, prevSelector, nextSelector, desktopPerView, mobilePerView) => {
          const el = root.querySelector(selector);
          if (!el) return;
          if (el.swiper) el.swiper.destroy(true, true);

          new Swiper(el, {
            slidesPerView: mobilePerView,
            spaceBetween: 8,
            speed: 500,
            watchOverflow: true,
            navigation: {
              prevEl: root.querySelector(prevSelector),
              nextEl: root.querySelector(nextSelector)
            },
            breakpoints: {
              768: {
                slidesPerView: desktopPerView,
                spaceBetween: 14
              }
            }
          });
        };

        initMainGallery();
        initVideoSwiper(
          '.js-cc-pdp-videos-desktop-' + SECTION_UID,
          '.js-cc-pdp-videos-prev-desktop-' + SECTION_UID,
          '.js-cc-pdp-videos-next-desktop-' + SECTION_UID,
          3,
          2.15
        );
        initVideoSwiper(
          '.js-cc-pdp-videos-mobile-' + SECTION_UID,
          '.js-cc-pdp-videos-prev-mobile-' + SECTION_UID,
          '.js-cc-pdp-videos-next-mobile-' + SECTION_UID,
          3,
          2.15
        );
      };

      ensureSwiper()
        .then(() => {
          bootSliders();
          let resizeTimer;
          window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(bootSliders, 180);
          });
        })
        .catch((err) => {
          console.warn('[cc-pdp] Swiper failed to load:', err && err.message ? err.message : err);
          // Fallback CSS keeps slides side-by-side so nothing looks broken
        });

      // Theme editor support — re-init when section reloads
      document.addEventListener('shopify:section:load', (event) => {
        if (event.detail && event.detail.sectionId === SECTION_UID) {
          bootFaq();
          if (typeof Swiper !== 'undefined') bootSliders();
        }
      });
    })();
  

    (() => {
      const sectionId = "template--22142084448508__review_slider_czwtXU";
      const root = document.getElementById(`cc-section-${sectionId}`);
      if (!root) return;

      const swiperSelector = `.js-cc-customer-notice-swiper-${sectionId}`;
      const prevSelector = `.js-cc-customer-notice-prev-${sectionId}`;
      const nextSelector = `.js-cc-customer-notice-next-${sectionId}`;
      const paginationSelector = `.js-cc-customer-notice-pagination-${sectionId}`;

      const initSlider = () => {
        if (typeof Swiper === "undefined") return;

        const swiperEl = root.querySelector(swiperSelector);
        if (!swiperEl) return;

        if (swiperEl.swiper) {
          swiperEl.swiper.destroy(true, true);
        }

        new Swiper(swiperEl, {
          slidesPerView: 1.12,
          spaceBetween: 12,
          speed: 500,
          loop: false,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          navigation: {
            prevEl: root.querySelector(prevSelector),
            nextEl: root.querySelector(nextSelector),
            disabledClass: "swiper-button-disabled"
          },
          pagination: {
            el: root.querySelector(paginationSelector),
            clickable: true,
            bulletClass: "swiper-pagination-bullet",
            bulletActiveClass: "swiper-pagination-bullet-active"
          },
          breakpoints: {
            750: {
              slidesPerView: 3,
              spaceBetween: 32
            }
          }
        });
      };

      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initSlider);
      } else {
        initSlider();
      }

      document.addEventListener("shopify:section:load", (event) => {
        if (event.detail && event.detail.sectionId === sectionId) {
          initSlider();
        }
      });

      document.addEventListener("shopify:block:select", (event) => {
        if (!event.target.closest(`#shopify-section-template--22142084448508__review_slider_czwtXU`)) return;
        const swiperEl = root.querySelector(swiperSelector);
        if (!swiperEl || !swiperEl.swiper) return;

        const slideEl = event.target.closest(".swiper-slide");
        if (!slideEl) return;

        const slides = Array.from(root.querySelectorAll(".swiper-slide"));
        const index = slides.indexOf(slideEl);
        if (index >= 0) {
          swiperEl.swiper.slideTo(index);
        }
      });
    })();
  

    (() => {
      const sectionId = "template--22142084448508__doctor_review_m9bnBb";
      const root = document.getElementById(`cc-section-${sectionId}`);
      if (!root) return;

      const swiperEl = root.querySelector(`.js-cc-doctors-see-swiper-${sectionId}`);
      const tabs = Array.from(root.querySelectorAll(".cc-doctors-see__tab"));

      const setActiveTab = (index) => {
        tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === index;
          tab.classList.toggle("is-active", isActive);
          tab.setAttribute("aria-selected", isActive ? "true" : "false");
        });
      };

      const initSlider = () => {
        if (!swiperEl || typeof Swiper === "undefined") return;

        if (swiperEl.swiper) {
          swiperEl.swiper.destroy(true, true);
        }

        const swiper = new Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 500,
          loop: false,
          autoHeight: false,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          on: {
            init() {
              setActiveTab(this.activeIndex);
            },
            slideChange() {
              setActiveTab(this.activeIndex);
            }
          }
        });

        tabs.forEach((tab) => {
          tab.addEventListener("click", () => {
            const index = Number(tab.dataset.index || 0);
            swiper.slideTo(index);
          });
        });
      };

      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initSlider);
      } else {
        initSlider();
      }

      document.addEventListener("shopify:section:load", (event) => {
        if (event.detail && event.detail.sectionId === sectionId) {
          initSlider();
        }
      });

      document.addEventListener("shopify:block:select", (event) => {
        if (!event.target.closest(`#shopify-section-template--22142084448508__doctor_review_m9bnBb`)) return;
        if (!swiperEl || !swiperEl.swiper) return;

        const tab = event.target.closest(".cc-doctors-see__tab");
        if (tab) {
          const index = Number(tab.dataset.index || 0);
          swiperEl.swiper.slideTo(index);
          return;
        }

        const slide = event.target.closest(".swiper-slide");
        if (!slide) return;

        const slides = Array.from(root.querySelectorAll(".swiper-slide"));
        const index = slides.indexOf(slide);
        if (index >= 0) {
          swiperEl.swiper.slideTo(index);
        }
      });
    })();
  

    (() => {
      const sectionId = "template--22142084448508__journey_timeline_FyAhiy";
      const root = document.getElementById(`cc-section-${sectionId}`);
      if (!root) return;

      // Mobile: move details below the image. Desktop: keep inside left column.
      const detailsEl = root.querySelector(".cc-timeline__details");
      const rightEl = root.querySelector(".cc-timeline__right");
      const leftEl = root.querySelector(".cc-timeline__left");

      const applyLayout = () => {
        if (!detailsEl || !rightEl || !leftEl) return;
        const isMobile = window.matchMedia("(max-width: 749px)").matches;
        if (isMobile) {
          if (rightEl.nextElementSibling !== detailsEl) {
            rightEl.parentNode.insertBefore(detailsEl, rightEl.nextSibling);
          }
        } else {
          if (detailsEl.parentElement !== leftEl) {
            leftEl.appendChild(detailsEl);
          }
        }
      };

      applyLayout();
      let _rt;
      window.addEventListener("resize", () => {
        clearTimeout(_rt);
        _rt = setTimeout(applyLayout, 100);
      });

      const swiperEl = root.querySelector(`.js-cc-timeline-swiper-${sectionId}`);
      const tabsWrap = root.querySelector(".cc-timeline__tabs");
      const tabs = Array.from(root.querySelectorAll(".cc-timeline__tab"));
      const details = Array.from(root.querySelectorAll(".cc-timeline__detail"));

      const setActiveState = (index) => {
        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.classList.toggle("is-active", active);
          tab.setAttribute("aria-selected", active ? "true" : "false");
        });

        details.forEach((detail, detailIndex) => {
          detail.classList.toggle("is-active", detailIndex === index);
        });
      };

      const initSlider = () => {
        if (!swiperEl || typeof Swiper === "undefined") return;

        if (swiperEl.swiper) {
          swiperEl.swiper.destroy(true, true);
        }

        const swiper = new Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 500,
          loop: false,
          allowTouchMove: true,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          on: {
            init() {
              setActiveState(this.activeIndex);
            },
            slideChange() {
              setActiveState(this.activeIndex);
            }
          }
        });

        if (tabsWrap) {
          tabsWrap.onclick = (event) => {
            const button = event.target.closest(".cc-timeline__tab");
            if (!button) return;
            const index = Number(button.dataset.index || 0);
            swiper.slideTo(index);
            setActiveState(index);
          };
        }
      };

      const boot = () => initSlider();

      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", boot, { once: true });
      } else {
        boot();
      }

      document.addEventListener("shopify:section:load", (event) => {
        if (event.detail && event.detail.sectionId === sectionId) {
          initSlider();
          applyLayout();
        }
      });

      document.addEventListener("shopify:block:select", (event) => {
        if (!event.target.closest(`#shopify-section-${sectionId}`)) return;
        if (!swiperEl || !swiperEl.swiper) return;

        const tab = event.target.closest(".cc-timeline__tab");
        if (tab) {
          const index = Number(tab.dataset.index || 0);
          swiperEl.swiper.slideTo(index);
          setActiveState(index);
          return;
        }

        const slide = event.target.closest(".swiper-slide");
        if (!slide) return;

        const slides = Array.from(root.querySelectorAll(".swiper-slide"));
        const index = slides.indexOf(slide);
        if (index >= 0) {
          swiperEl.swiper.slideTo(index);
          setActiveState(index);
        }
      });
    })();
  

  (() => {
    const section = document.getElementById('aurivita-stats-template--22142084448508__cc_worth_knowing_stats_UdntGP');
    if (!section) return;

    const track = section.querySelector('[data-stats-track]');
    const dots = Array.from(section.querySelectorAll('[data-stats-dot]'));
    const slides = Array.from(section.querySelectorAll('.aurivita-stats__slide'));

    if (!track || !slides.length || !dots.length) return;

    let current = 0;
    let startX = 0;
    let isDragging = false;

    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function goTo(index) {
      current = Math.max(0, Math.min(index, slides.length - 1));

      if (isMobile()) {
        track.style.transform = `translateX(-${current * 100}%)`;
      } else {
        track.style.transform = '';
      }

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === current);
      });
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        goTo(Number(dot.dataset.statsDot || 0));
      });
    });

    track.addEventListener('touchstart', (event) => {
      if (!isMobile()) return;
      startX = event.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    track.addEventListener('touchend', (event) => {
      if (!isMobile() || !isDragging) return;

      const endX = event.changedTouches[0].clientX;
      const diff = startX - endX;

      if (Math.abs(diff) > 40) {
        if (diff > 0) {
          goTo(current + 1);
        } else {
          goTo(current - 1);
        }
      }

      isDragging = false;
    }, { passive: true });

    window.addEventListener('resize', () => goTo(current));

    goTo(0);
  })();


    (() => {
      const root = document.getElementById('aurivita-compare-template--22142084448508__aurivita_vs_other_brands_BMjz8e');
      if (!root) return;

      const scroller = root.querySelector('[data-avs-scroller]');
      const dots = Array.from(root.querySelectorAll('[data-avs-dot]'));
      if (!scroller || !dots.length) return;

      const getStep = () => {
        const card = scroller.querySelector('.avs__card--mobile');
        const track = scroller.querySelector('.avs__mobile-track');
        if (!card || !track) return 1;
        const gap = parseFloat(getComputedStyle(track).gap || 12) || 12;
        return card.offsetWidth + gap;
      };

      const update = () => {
        const step = getStep();
        const index = Math.round(scroller.scrollLeft / step);
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      };

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          scroller.scrollTo({ left: getStep() * index, behavior: 'smooth' });
        });
      });

      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    })();
  

    (() => {
      const root = document.getElementById('cc-section-template--22142084448508__custom_faqs_ALDxdr');
      if (!root) return;

      const items = Array.from(root.querySelectorAll('.cc-faq__item'));

      const closeItem = (item) => {
        item.classList.remove('is-open');
        const button = item.querySelector('.cc-faq__toggle');
        if (button) button.setAttribute('aria-expanded', 'false');
      };

      const openItem = (item) => {
        item.classList.add('is-open');
        const button = item.querySelector('.cc-faq__toggle');
        if (button) button.setAttribute('aria-expanded', 'true');
      };

      items.forEach((item) => {
        const button = item.querySelector('.cc-faq__toggle');
        if (!button) return;

        button.addEventListener('click', () => {
          const isOpen = item.classList.contains('is-open');
          items.forEach((other) => {
            if (other !== item) closeItem(other);
          });

          if (isOpen) {
            closeItem(item);
          } else {
            openItem(item);
          }
        });
      });

      document.addEventListener('shopify:block:select', (event) => {
        if (!event.target.closest('#shopify-section-template--22142084448508__custom_faqs_ALDxdr')) return;
        const item = event.target.closest('.cc-faq__item');
        if (!item) return;

        items.forEach((other) => {
          if (other !== item) closeItem(other);
        });

        openItem(item);
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    })();
  

(function () {
  var root = document.getElementById('shopify-section-template--22142084448508__cc_nutritional_popup_NKUt4F');
  if (!root) return;

  root.querySelectorAll('[data-csi-accordion]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      trigger.setAttribute('aria-expanded', String(!expanded));
      if (!panel) return;

      if (expanded) {
        panel.style.setProperty('--csi-panel-h', panel.scrollHeight + 'px');
        requestAnimationFrame(function () {
          panel.dataset.open = 'false';
          panel.style.setProperty('--csi-panel-h', '0px');
        });
        panel.addEventListener('transitionend', function handler() {
          panel.hidden = true;
          panel.removeEventListener('transitionend', handler);
        });
      } else {
        panel.hidden = false;
        panel.style.setProperty('--csi-panel-h', panel.scrollHeight + 'px');
        panel.dataset.open = 'true';
      }
    });
  });

  var modal = root.querySelector('#science-modal');
  if (!modal) return;

  var openers = root.querySelectorAll('[data-csi-open]');
  var closer = modal.querySelector('[data-csi-close]');
  var dialog = modal.querySelector('[data-csi-dialog]');
  var lastFocused = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function focusables() {
    return Array.prototype.filter.call(
      modal.querySelectorAll(FOCUSABLE),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      closeModal();
      return;
    }
    if (e.key !== 'Tab') return;

    var items = focusables();
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openModal(triggerEl) {
    lastFocused = triggerEl || document.activeElement;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    if (closer) closer.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  openers.forEach(function (btn) {
    btn.addEventListener('click', function () {
      openModal(btn);
    });
  });

  document.addEventListener('click', function (e) {
    var externalTrigger = e.target.closest('[data-csi-open-target="science-modal"]');
    if (!externalTrigger) return;

    e.preventDefault();
    openModal(externalTrigger);
  });

  if (closer) closer.addEventListener('click', closeModal);

  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });

  if (dialog) {
    dialog.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  }

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.detail && e.detail.sectionId === 'template--22142084448508__cc_nutritional_popup_NKUt4F') {
      document.body.style.overflow = '';
    }
  });



  window.openScienceModal = function (triggerEl) {
  openModal(triggerEl);
};

window.closeScienceModal = function () {
  closeModal();
};
})();
